import React from 'react';
import { motion } from 'framer-motion';
import { Download, RefreshCw, Play } from 'lucide-react';
const steps = [{
  icon: Download,
  title: 'Download',
  desc: 'Get instant access to the Protocol and the SOS Checklist.'
}, {
  icon: RefreshCw,
  title: 'Sync',
  desc: 'Identify your specific recovery bottleneck (Temp, Light, or Stress).'
}, {
  icon: Play,
  title: 'Execute',
  desc: 'Apply the 7-day plan and watch your metrics shift in real-time.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-brand-dark" data-id="element-83">
      <div className="max-w-6xl mx-auto px-6" data-id="element-84">
        <div className="text-center mb-16" data-id="element-85">
          <h2 className="text-4xl font-bold mb-4" data-id="element-86">How It Works</h2>
        </div>

        <div className="relative" data-id="element-87">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-brand-panelBorder" data-id="element-88" />

          <div className="grid md:grid-cols-3 gap-12 relative z-10" data-id="element-89">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.2
            }} className="text-center" data-id="element-90">
                  <div className="w-24 h-24 mx-auto bg-[#111] border-2 border-brand-panelBorder rounded-full flex items-center justify-center mb-6 relative" data-id="element-91">
                    <Icon className="w-10 h-10 text-brand-green" data-id="element-92" />
                    <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-brand-green text-black font-bold flex items-center justify-center text-sm" data-id="element-93">
                      {index + 1}
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold mb-3" data-id="element-94">{step.title}</h3>
                  <p className="text-brand-gray" data-id="element-95">{step.desc}</p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}